import React, { useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { Fragment } from "react";
import { Progress } from "../../shared";
import { Row, Spinner } from "react-bootstrap";
function AgGridDataTable(props) {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridOptions, setAgGridOptions] = useState({
    initialPageSize: props.initialPageSize,
  });
  const [agGridDefColDef, setAgGridDefColDef] = useState({
    resizable: true,
    unSortIcon: true,
    width: 100
  });
  const overlayNoRowsTemplate = `<div><span class="ag-grid-overlay-norows">No results found matching your search critera.</span></div>`;
  const overlayLoadingTemplate = "<p></p>";

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    params.api.hideOverlay();
    params.api.refreshCells();
    if (props.csvOnly === true) {
      params.api.setDomLayout("0");
    } else {
      params.api.setDomLayout("autoHeight");
    }
    params.api.sizeColumnsToFit();
  };

  const onFirstDataRendered = (params) => {
    params.api.sizeColumnsToFit();
    if (
      props.pageTitle === "Search for a Handler (Advanced)" ||
      props.pageTitle === "Waste Code By Year Matrix Report" ||
      props.pageTitle === "TQR Detail Report by Manifest" ||
      props.pageTitle === "Shipments by Waste Code" ||
      props.pageTitle === "Tanner Report (Regulatory)" ||
      props.pageTitle === "Tanner_Facilities" ||
      props.pageTitle === "Search By" ||
      props.pageTitle === "Transporter Days In Transit" ||
      props.pageTitle === "Transporter Waste Detail" ||
      props.pageTitle === "Transporter Summary" ||
      props.pageTitle === "Historical Manifests Report" ||
      props.pageTitle === "Tanner Report (Regulatory)" ||
      props.pageTitle === "Large Quantity Generators Report" ||
      props.pageTitle === "Generator Waste Summary by Region" ||
      props.pageTitle === "Find Manifests" ||
      props.pageTitle === "Notification of LQG Site Closure"
    ) {
      params.columnApi.autoSizeAllColumns();
    }
  };

  const onPageSizeChanged = (e) => {
    props.agGridRef.current.api.paginationSetPageSize(e.target.value);
  };

  const onBtPrinterFriendly = () => {
    if (gridApi && gridColumnApi) {
      var pageContainer = document.getElementById("page-container");
      if (pageContainer) pageContainer.classList.remove('container');
      if (props.csvOnly === true) {
        gridApi.setDomLayout("0");
      } else {
        gridApi.setDomLayout("print");
        gridApi.sizeColumnsToFit();
        //gridColumnApi.autoSizeAllColumns();
      }
    }
  };

  const onBtNormal = () => {
    if (gridApi) {
      var eGridDiv = document.querySelector('#hwts-report-grid');
      var pageContainer = document.getElementById("page-container");
      if (pageContainer) pageContainer.classList.add('container');
      if (props.csvOnly === true) {
        gridApi.setDomLayout("0");
      } else {
        gridApi.setDomLayout("autoHeight");
        gridApi.sizeColumnsToFit();
      }
    }
  };

  window.addEventListener("beforeprint", () => onBtPrinterFriendly());
  window.addEventListener("afterprint", () => onBtNormal());

  let paramString = "";
  if (props.formParams) {
    let reportParams = Object.keys(props.formParams).map((param) => {
      if (props.formParams[param]) {
        props.formConfig.map((key, idx) => {
          let origkey = key.name;
          if (key.name.startsWith("multi")) {
            key.name = key.name.substr(5);
          }
          if (key.name === param) {
            paramString =
              paramString + `${key.config.label}: ${props.formParams[param]} `.toUpperCase() + '';
          }
          key.name = origkey;
        });
      }
    });
  }

  const csvExport = (e) => {
    const date = new Date();
    const params = {
      columnGroups: true,
      fileName: `${props.pageTitle}_${date.toLocaleDateString("en-US")}.csv`,
      customHeader: props.customCsvHeader
        ? props.customCsvHeader
        : [
          [],
          [
            {
              data: {
                value: `${props.pageTitle}`,
                type: "String",
              },
            },
          ],
          [
            {
              data: {
                value: `The Department of Toxic Substances Control (DTSC) takes every precaution to ensure the accuracy of data in`,
                type: "String",
              },
            },
          ],
          [
            {
              data: {
                value: `the Hazardous Waste Tracking System (HWTS). However because of the large number of manifests handled`,
                type: "String",
              },
            },
          ],
          [
            {
              data: {
                value: `inaccuracies in the submitted data and limitations of the manifest system and the technical limitations of the`,
                type: "String",
              },
            },
          ],
          [
            {
              data: {
                value: `database DTSC cannot guarantee that the data accurately reflect what was actually transported or produced.`,
                type: "String",
              },
            },
          ],
          [
            {
              data: {
                value: `Report Generated: ${date.toLocaleDateString("en-US") + ' ' + date.toLocaleTimeString("en-US")}`,
                type: "String",
              },
            },
          ],
          [
            {
              data: {
                value: `${paramString}`,
                type: "String",
              },
            },
          ],
          [],
        ],
    };
    props.agGridRef.current.api.exportDataAsCsv(params);
  };

  return (
    <Fragment>
      <Row className="mx-0">
        {/* <div style={{ textAlign: "left" }}> */}
        {props.rowData.length === 0 || props.hideRecordCnt === true ? null : (
          <span
            className="mr-auto"
            style={{
              fontWeight: "bold",
            }}
          >
            {props.rowData.length} Record
            {props.rowData.length > 1 ? "s" : ""}

          </span>
        )}
        {/* </div> */}
        {/* <div style={{ textAlign: "right" }}> */}
        {props.hideCsvExport === true ? null : (
          <button
            className="btn btn-standout ml-auto"
            style={{
              fontSize: "0.85rem",
              padding: "0.3rem 0.5rem",
              bottom:
                props.hidePagination && props.hidePagination === true ? -3 : 29,
            }}
            onClick={(e) => csvExport(e)}
            disabled={props.rowData.length < 1}
          >
            Export CSV
          </button>
        )}
        {/* </div> */}
      </Row>
      <div
        id="hwts-report-grid"
        className="ag-theme-balham"
        style={
          props.csvOnly === true
            ? { marginTop: 5, marginBottom: -5, height: "100%", width: "100%" }
            : { marginTop: 5, marginBottom: 5, height: "100%", width: "100%" }
        }
      >
        <AgGridReact
          ref={props.agGridRef}
          onGridReady={onGridReady}
          defaultColDef={agGridDefColDef}
          defaultExportParams={props.defaultExportParams}
          columnDefs={props.columnDefs}
          rowData={props.rowData}
          pagination={
            props.hidePagination && props.hidePagination === true ? false : true
          }
          paginationPageSize={agGridOptions.initialPageSize}
          //domLayout={props.csvOnly === true ? "0" : "autoHeight"}
          enableCellTextSelection={true}
          onFirstDataRendered={onFirstDataRendered}
          onRowDataChanged={onFirstDataRendered}
          overlayNoRowsTemplate={overlayNoRowsTemplate}
          // frameworkComponents={{
          //   progress: Progress,
          // }}
          // loadingOverlayComponent={"progress"}
          // loadingOverlayComponentParams={{
          //   loadingMessage: "Fetching Result",
          //   percent: props.progressPercentage,
          //   setProgressPercentage: props.setProgressPercentage,
          // }}
          // overlayLoadingTemplate={overlayLoadingTemplate}
          overlayLoadingTemplate={overlayLoadingTemplate}
          headerHeight={props.csvOnly === true ? 0 : 45}
          animateRows={true}
          filter={true}
        ></AgGridReact>

        {props.hidePagination && props.hidePagination === true ? null : (
          <div
            className="test-header"
            style={{
              position: "relative",
              bottom: 25,
              marginRight: "260px",
              width: "200px",
              float: "right",
            }}
          >
            Page Size:
            <select
              className="m-l-sm"
              onChange={(e) => onPageSizeChanged(e)}
              id="page-size"
              defaultValue={props.initialPageSize ? props.initialPageSize : 10}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value={props.rowData.length}>All</option>
            </select>
          </div>
        )}
      </div>
    </Fragment>
  );
}

export default AgGridDataTable;
